    <mapfre-card [singleCard]="false" [additionalClasses]="'contact details'">
  <section class="details-content row no-margin">
    <ng-container *ngIf="isAcmic; else MAstate">
      <div class="col">
        <div class="row margin-bottom mb24">
          <div class="col">
            <h2 class="title contact_black margin-bottom mb16">
              {{ "NEED_HELP" | translate }}
            </h2>
            <div>
              <p>
                {{ "CONTACT_OUR_EXCEPTIONAL_CUSTOMER_SERVICE" | translate }}
              </p>
              <ul>
                <li>
                  {{ "POLICY_CHANGES_COVERAGES_DISC_INFO" | translate }}
                </li>
                <li>
                  {{ "BILLING_INFO" | translate }}
                </li>
                <li>
                  {{ "NEW_EXISTING_CLAIMS" | translate }}
                </li>
              </ul>
            </div>
            <div>
              <p>
                <strong>{{ "CALL_US" | translate }}:
                <span>
                  <a
                    href="tel:18442954500"
                    class="underlineBQ mapfre link blue-link"
                    >1-844-295-4500</a
                  >
                </span>
            </strong>
              </p>
              <p>{{ "NEW_CONTACT_CENTER_HOURS" | translate }}</p>
            </div>

            <div class="margin-top mt4">
              <app-billing-question></app-billing-question>
            </div>
          </div>
        </div>

        <div class="row margin-bottom mb24">
          <div class="col">
            <h2 class="title contact_black margin-bottom mb16">
              {{ "TO_MAIL_A_PAYMENT_OR_CORRESPONDENCE" | translate }}
            </h2>
            <div class="row">
              <div class="col-md-6 col-12 margin-bottom mb16">
                <h6 class="font-bold fake-black-color">
                  {{ "PAYMENT_TITLE" | translate }}
                </h6>

                <span class="fs-12">{{
                  "AUTO_CLUB_MAPFRE_PART1" | translate
                }}</span>
                <br />
                <span class="fs-12">{{
                  "AUTO_CLUB_MAPFRE_PART2" | translate
                }}</span>
              </div>
              <div class="col-md-6 col-12 margin-bottom mb16">
                <h6 class="font-bold fake-black-color">
                  {{ "CORRESPONDENCE_TITLE" | translate }}
                </h6>
                <span class="fs-12">
                  {{ "AAA_INSURANCE_PART1" | translate }},<br/>
                  {{ "POBOX_3" | translate }}, {{ "ADDRESS_PART_TWO" | translate }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #MAstate>
      <div class="col col1">
        <div
          style="display: block;"
          class="row margin-bottom mb24"
          *ngIf="both"
        >
          <mapfre-info-divs>
            <em>
              <div class="mb10">
                <b *ngIf="allLivoPolicy.length > 1">{{
                  "MULTIPLE_POLICY" | translate
                }}</b>
                <b *ngIf="allLivoPolicy.length === 1">{{
                  "SINGLE_POLICY" | translate
                }}</b>
              </div>
            </em>
            <div
              class="row policy-row mb-50"
              *ngFor="let policy of allLivoPolicy"
            >
              <div class="col-12 col-md-6">
                <ng-container>
                  <div style="display: flex;" class="mb10">
                    <div
                      class="policy-icon policy-icon-top float-left margin-right mr8 auto-svg"
                    >
                      <span
                        *ngIf="
                          policy.policyType === 'AUTO' ||
                          policy.policyType === 'COMMERCIAL_AUTO'
                        "
                        ><ng-container *ngIf="isAcmic; else nonAcmicCarIcon">
                          <img src="assets/img/images/icon-car-24.svg"  alt="car icon" />
                        </ng-container>
                        <ng-template #nonAcmicCarIcon>
                          <svg-car-mono-color-small-svg></svg-car-mono-color-small-svg>
                        </ng-template>
                      </span>
                      <span *ngIf="policy.policyType === 'HOME'"
                        ><ng-container *ngIf="isAcmic; else nonAcmicHomeIcon">
                          <img src="assets/img/images/icon-home-24.svg"  alt="home icon" />
                        </ng-container>
                        <ng-template #nonAcmicHomeIcon>
                          <svg-house-mono-color-small-svg></svg-house-mono-color-small-svg>
                        </ng-template>
                      </span>
                      <span *ngIf="policy.policyType === 'UMBRELLA'"
                        ><svg-umbrella-svg></svg-umbrella-svg
                      ></span>
                      <span *ngIf="policy.policyType === 'SCHEDULED_PROPERTY'"
                        ><ng-container *ngIf="isAcmic; else nonAcmicUmbrellaIcon">
                          <img src="assets/img/images/icon-umbrella-acmic.svg"  alt="umbrella icon" />
                        </ng-container>
                        <ng-template #nonAcmicUmbrellaIcon>
                          <svg-umbrella-svg></svg-umbrella-svg>
                        </ng-template>
                      </span>
                      <span
                        *ngIf="
                          policy.policyType === 'DWELLING_FIRE_PERSONAL' ||
                          policy.policyType === 'COMMERCIAL_FIRE'
                        "
                        ><svg-dwelling-fire-svg></svg-dwelling-fire-svg
                      ></span>
                      <span *ngIf="policy.policyType === 'GARAGE_KEEPER'"
                        ><svg-garage-svg></svg-garage-svg
                      ></span>
                      <span
                        *ngIf="
                          policy.policyType === 'GENERAL_LIABILITY' ||
                          policy.policyType === 'SPECIAL_MULTI_PERIL'
                        "
                        ><svg-liability-svg></svg-liability-svg
                      ></span>
                    </div>
                    <div class="policy-info">
                      <div class="policy-info-contents">
                        {{ policy?.displayType?.label | titlecase }}:
                      </div>
                    </div>
                    <div class="policyNumberBold">
                      <b>&nbsp;{{ policy?.policynumber.policyNumber }}</b>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
            <span>{{ "CONTACT_US_AT" | translate }}</span
            ><b
              ><a href="tel:18556273737" class="mapfre link red-link dm-sans-medium underline"
                >1-855-627-3737</a
              ></b
            >
          </mapfre-info-divs>
        </div>
        <div class="row margin-bottom mb32">
          <div class="col">
            <h2 class="title margin-bottom mb16 dm-sans-medium font-weight-500">
              {{ "NEW_AND_EXISTING_CLAIMS" | translate }}
            </h2>
            <div class="dm-sans-medium font-class font-weight-500 med-grey font-small" *ngIf="showCompany==='all'">
              {{ "For Massachusetts policies only" }}
            </div>
            <div>
              <ng-container *ngIf="showCompany==='ma' || showCompany==='all'">
              <span class="contact-claims">{{ "PHONE" | translate }}</span>
              
            
                <a
                *ngIf="livoNumber"
                href="tel:18556273737"
                class="mapfre link red-link dm-sans-medium font-weight-500 underline"
                >1-855-627-3737</a
              ><span *ngIf="as400Number"
                ><a
                  href="tel:18009228276"
                  class="mapfre link red-link dm-sans-medium font-weight-500 underline"
                  >1-800-922-8276</a
                > </span
                > 
             
              <div class="info dm-sans-medium font-weight-500 mb-3 mt-1">{{ "AVAILABLE_24_7" | translate }}</div>
            </ng-container>
              <ng-container *ngIf="showCompany!=='ma'">
                <ng-container *ngIf="showCompany==='all'">
                  <div class="dm-sans-medium font-class font-weight-500 med-grey font-small">
                    {{ "For all other states outside of Massachusetts" }}
                  </div>
                </ng-container>
                <span class="contact-claims">{{ "PHONE" | translate }}</span>
                <a
                href="tel:18776273731"
                class="mapfre link red-link dm-sans-medium font-weight-500 underline"
                >1-877-Mapfre1 (1-877-627-3731)</a>
                <div class="info dm-sans-medium font-weight-500 mb-3 mt-1">{{ "AVAILABLE_24_7" | translate }}</div>
              </ng-container>                
               
              
              <ng-container *ngIf="showCompany==='ma'">
              <span class="contact-claims">{{ "FAQ_NEW" | translate }}</span
              ><span class="font-class brand-blue-secondary">{{ "FAQ_MSG" | translate }}</span
              ><a
                routerLink="/claims"
                class="mapfre link red-link dm-sans-medium font-weight-500 underline"
                >{{ "CLAIM_AREA" | translate }}</a
              >
            </ng-container>
            </div>
          </div>
        </div>

        <div class="row margin-bottom mb32">
          <div class="col">
            <h2 class="title margin-bottom mb16 mt-3 dm-sans-medium font-weight-500">
              {{ "BILLING_CUSTOMER_SERVICE_QUOTES" | translate }}
            </h2>
            <div class="dm-sans-medium font-class font-weight-500 med-grey font-small" *ngIf="showCompany==='all'">
              {{ "For Massachusetts policies only" }}
            </div>
            <ng-container *ngIf="showCompany==='ma' || showCompany==='all'">
              <div>
              <span class="contact-claims">{{ "PHONE" | translate }}</span>
              
                <a
                *ngIf="livoNumber"
                href="tel:18556273737"
                class="mapfre link red-link dm-sans-medium font-weight-500 underline"
                >1-855-627-3737</a
              ><span *ngIf="as400Number"
                ><a
                  href="tel:18009228276"
                  class="mapfre link red-link dm-sans-medium font-weight-500 underline"
                  >1-800-922-8276</a
                ></span
              >
              <div class="info margin-bottom mb4 mt-1 dm-sans-medium font-weight-500 contact-center-wide">
                {{ "CONTACT_CENTER_HOURS" | translate }} |
                {{ "CONTACT_CENTER_HOURS_2" | translate }} {{ "(EST)" }}
              </div>
              <div class="info mt-1 dm-sans-medium font-weight-500 contact-center-mobile">
                {{ "CONTACT_CENTER_HOURS" | translate }}
              </div>
              <div class="info dm-sans-medium font-weight-500 contact-center-mobile">
                {{ "CONTACT_CENTER_HOURS_2" | translate }} {{ "(EST)" }}
              </div>
              <div class="margin-top mt16">
                <app-billing-question></app-billing-question>
              </div>
            </div>
          </ng-container>  

            <ng-container *ngIf="showCompany!=='ma'">
              <ng-container *ngIf="showCompany==='all'">
                <div class="dm-sans-medium font-class font-weight-500 med-grey font-small margin-top mt16">
                  {{ "For all other states outside of Massachusetts" }}
                </div>
              </ng-container>
                <span class="contact-claims">{{ "PHONE" | translate }}</span>
              <a
              href="tel:18776273731"
              class="mapfre link red-link dm-sans-medium font-weight-500 underline"
              >1-877-Mapfre1 (1-877-627-3731)</a>
              <div class="info margin-bottom mb4 mt-1 dm-sans-medium font-weight-500 contact-center-wide">
                {{ "Monday to Friday 8am to 8pm (EST)" | translate }}
              </div>
            </ng-container>       

          </div>
        </div>
        
        <div class="row margin-bottom mb16">
          <div class="col">
            <h2 class="title margin-bottom mb16 dm-sans-medium font-weight-500">
              {{ "TO_MAIL_A_PAYMENT_OR_CORRESPONDENCE" | translate }}
            </h2>
            <div class="row fake-black-color">
              <div class="col-md-6 col-12 margin-bottom mb16">
                <h6 class="dm-sans-medium font-weight-500">
                  {{ "PAYMENT_TITLE" | translate }}
                </h6>
                <div class="dm-sans-medium font-class font-weight-500 med-grey font-small" [ngClass]="{'col-9CB0BC lh-16 margin-bottom mb8':!isAcmic}">
                  {{ "FOR_OTHER_STATES_OUTSIDE_CALIFORNIA" | translate }}
                </div>
                <span class="dm-sans-medium font-weight-500" [ngClass]="{'lh-16 font-weight-700 margin-bottom mb8':!isAcmic}">{{ "COMPANY_NAME" | translate }}</span
                >
                <span class="font-class addr-block">{{ "POBOX_1" | translate }}</span>
                <span class="font-class addr-block">{{ "POBOX_2" | translate }}</span>
                <div class="dm-sans-medium font-class font-weight-500 med-grey font-small margin-top mt16" [ngClass]="{'col-9CB0BC lh-16 margin-bottom mb8':!isAcmic}">
                  {{ "FOR_CALIFORNIA_POLICIES_ONLY" | translate }}
                  </div>
                  <span class="dm-sans-medium font-weight-500" [ngClass]="{'lh-16 font-weight-700 margin-bottom mb8':!isAcmic}">{{ "COMPANY_NAME" | translate }}</span
                    >
                    <span class="font-class addr-block">{{ "POBOX" | translate }}{{ "52234" }}</span>
                    <span class="font-class addr-block">{{ "Phoenix, AZ 85072" }}</span>
              </div>
              <div class="col-md-6 col-12 margin-bottom mb16">
                <h6 class="dm-sans-medium font-weight-500 fake-black-color">
                  {{ "CORRESPONDENCE_TITLE" | translate }}
                </h6>
                <span class="dm-sans-medium font-weight-500" [ngClass]="{'font-weight-700 lh-16 margin-bottom mb8':!isAcmic}">{{ "COMPANY_NAME" | translate }}</span
                ><br />
                  <span class="font-class addr-block">
                    {{ "POBOX_3" | translate }}
                  </span>
                    <span class="font-class addr-block">
                    {{ "ADDRESS_PART_TWO" | translate }}
                    </span>
              </div>
            </div>
          </div>
        </div>

        <div class="row ma-social-icons">
          <div class="col">
            <h6 class="brand-blue-secondary dm-sans-medium font-class font-weight-500 margin-bottom mb16">
              {{ "FOLLOW_US" | translate }}
            </h6>
            <ng-container *ngIf="!isApp">
              <ul class="social inline">
                <li>
                  <a
                    href="https://www.facebook.com/mapfreinsurance"
                    target="_blank"
                    rel="noopener"
                    class="mapfre link brands facebook"
                    >                    
                    <img src="./assets/img/images/gray-icon-facebook.svg" alt="icon-facebook">                    
                </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/mapfre/"
                    target="_blank"
                    rel="noopener"
                    class="mapfre link brands linkedin "
                    >
                    <img src="./assets/img/images/gray-icon-linkedin.svg" alt="icon-linkedin">                    
                </a>
                </li>                
                <li>
                  <a
                    href="https://twitter.com/mapfreins"
                    target="_blank"
                    rel="noopener"
                    class="mapfre link brands twitter"
                    >
                    <img src="./assets/img/images/gray-icon-twitter.svg" alt="icon-twitter">                    
                </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/user/mapfreins"
                    target="_blank"
                    rel="noopener"
                    class="mapfre link brands youtube "
                    >
                    <img src="./assets/img/images/gray-icon-youtube.svg" alt="icon-youtube">                   
                </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/mapfreinsurance/"
                    target="_blank"
                    rel="noopener"
                    class="mapfre link brands instagram "
                    >
                    <img src="./assets/img/images/gray-icon-instagram.svg" alt="icon-instagram">                    
                </a>
                </li>
              </ul>
            </ng-container>
            <ng-container *ngIf="isApp">
              <ul class="social inline margin-bottom mb16">
                <li>
                  <a
                    href="javascript:void(0);"
                    (click)="
                      onClickSocialMedia(
                        'https://www.facebook.com/mapfreinsurance'
                      )
                    "
                    class="mapfre link brands facebook"
                    >
                    <img src="./assets/img/images/gray-icon-facebook.svg" alt="icon-facebook">
                </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    (click)="
                      onClickSocialMedia(
                        'https://www.linkedin.com/company/mapfre/'
                      )
                    "
                    class="mapfre link brands linkedin"
                    >
                    <img src="./assets/img/images/gray-icon-linkedin.svg" alt="icon-linkedin">
                </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    (click)="
                      onClickSocialMedia('https://twitter.com/mapfreins')
                    "
                    class="mapfre link brands twitter"
                    >
                    <img src="./assets/img/images/gray-icon-twitter.svg" alt="icon-twitter">
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    (click)="
                      onClickSocialMedia(
                        'https://www.youtube.com/user/mapfreins'
                      )
                    "
                    class="mapfre link brands youtube"
                    >
                    <img src="./assets/img/images/gray-icon-youtube.svg" alt="icon-youtube">
                </a>
                </li>                
                <li>
                  <a
                    href="javascript:void(0);"
                    (click)="
                      onClickSocialMedia(
                        'https://www.instagram.com/mapfreinsurance/'
                      )
                    "
                    class="mapfre link brands instagram"
                    >
                    <img src="./assets/img/images/gray-icon-instagram.svg" alt="icon-instagram">
                </a>
                </li>
              </ul>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="col col2">
        <div class="row">
          <div class="col">
            <h2 class="title margin-bottom mb16 dm-sans-medium font-weight-500">
              <ng-container *ngIf="policies?.length === 1; else multipleAgents">
                <div>{{ "CONTACT_YOUR_AGENT" | translate }}</div>
              </ng-container>
              <ng-template #multipleAgents>
                <div>{{ "CONTACT_YOUR_AGENTS" | translate }}</div>
              </ng-template>
            </h2>
            <div class="dm-sans-medium font-class font-weight-500 med-grey font-small margin-bottom mb8" [ngClass]="{'contact-agent-text margin-bottom mb16': !isAcmic}">
              {{ "FOR_POLICY_CHANGES_COVERAGES_DISCOUTS" | translate }}
            </div>
            <ng-container *ngIf="loading">
              <mapfre-loading></mapfre-loading>
            </ng-container>
            <div *ngIf="!loading">
              <ng-container *ngFor="let policy of policies; index as key">
                <ng-container *ngIf="!policy[0]?.isNewPolicy">
                  <div class="agent-info  margin-bottom mb32">
                    <div class="row agent-name margin-bottom mb8 dm-sans-medium font-weight-500">
                      <div class="col">
                        {{ policy[0]?.agent?.agentName }}
                      </div>
                    </div>
                    <!-- <ng-container *ngFor="let pol of policy">
                      <div class="row policy-info margin-bottom mb8">
                        <div class="col text-capitalize">
                          {{
                            pol?.policyType
                              | translate
                              | replaceUnderscoreWithSpace
                              | titlecase
                          }}
                          &mdash;
                          <span class="fs-14 ">{{
                            pol?.policynumber?.policyNumber
                          }}</span>
                        </div>
                      </div>
                    </ng-container> -->
                    <div class="row agent-address margin-bottom mb8" *ngIf="policy[0]?.agent?.address">
                      <div class="col">
                        {{ policy[0]?.agent?.address?.streetName | titlecase }}
                        {{ policy[0]?.agent?.address?.city | titlecase }}
                        {{ policy[0]?.agent?.address?.stateCode }},
                        {{ policy[0]?.agent?.address?.zipCode?.code }}
                      </div>
                    </div>
                    <div
                      class="row agent-phone margin-bottom mb8"
                      *ngIf="policy[0]?.agent?.agentISCPhone?.number"
                    >
                      <div class="col col-description">
                        <span class="contact-claims">{{ "PHONE" | translate }}</span>
                      </div>
                      <div class="col col-info">
                        <a
                          href="tel:{{ policy[0]?.agent.agentISCPhone.number }}"
                          class="mapfre link underline red-link dm-sans-medium font-weight-700"
                          >{{
                            policy[0]?.agent?.agentISCPhone?.number
                              | formatPhone
                          }}</a
                        >
                      </div>
                    </div>
                    <div
                      class="row agent-phone margin-bottom mb8"
                      *ngIf="
                        policy[0]?.agent?.agentPhone?.number &&
                        !policy[0]?.agent?.agentISCPhone?.number
                      "
                    >
                      <div class="col col-description">
                        <span class="contact-claims">{{ "PHONE" | translate }}</span>
                      </div>
                      <div class="col col-info">
                        <a
                          href="tel:{{ policy[0]?.agent.agentPhone.number }}"
                          class="mapfre link underline red-link dm-sans-medium font-weight-700"
                          >{{
                            policy[0]?.agent?.agentPhone?.number | formatPhone
                          }}</a
                        >
                      </div>                     
                    </div>
                    <div 
                      class="row agent-email margin-bottom mb8"
                      *ngIf="policy[0]?.agent?.agentEmail && policy[0]?.agent?.agentEmail.trim().length > 0"
                    >
                      <div class="col col-description">
                        {{ "EMAIL" | translate }}:
                      </div>
                      <div class="col col-info">
                        <a href="mailto:{{ policy[0]?.agent?.agentEmail }}"
                          class="mapfre link underline red-link dam-sans-medium font-weight-700"
                          >{{ policy[0]?.agent?.agentEmail }}</a>
                      </div>
                    </div>
                    <div class="dm-sans-medium font-class font-weight-500 med-grey font-small" [ngClass]="{'contact-agent-text contact-agent-space': !isAcmic}">
                      <ng-container *ngIf="policy.length<=1">
                         {{ "Policy number" }} 
                      </ng-container>
                      <ng-container *ngIf="policy.length>1"> 
                          {{ "Policy numbers" }}
                      </ng-container>
                    </div>
                    <ng-container *ngFor="let pol of policy">
                      <div class="row policy-info margin-bottom mb8">
                        <div class="col">
                          <div class="display-inline fs-14 margin-right mr8">
                            {{ pol?.displayType?.label | translate }}
                          </div>
                          
                          <div class="display-inline "> 
                            <span class="fs-14 ">
                              <strong>{{pol?.policynumber?.policyNumber}}</strong>
                            </span>
                        </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="showCompany!=='ma' && showCompany!=='all' ">
                <h2 class="title margin-bottom mb16 dm-sans-medium font-weight-500">
                    <div>{{ "Billing Question" | translate }}</div>
                </h2>
                <div class="dm-sans-medium font-class font-weight-500 med-grey font-small margin-bottom mb8">
                  {{ "Have a question about this policy?" | translate }}
                </div>
                <div class="margin-top mt16">
                  <app-billing-question [isLegacy]="true"></app-billing-question>
                </div>
              </ng-container>

            </div>
          </div>
        </div>
        <!-- <div class="row">
          <div class="col">
            <h2 class="title margin-bottom mb16 dm-sans-medium font-weight-500">
                <div>{{ "Billing questions" | translate }}</div>
            </h2>
            <div class="dm-sans-medium font-class font-weight-500 grey-color font-small">
              {{ "Have a question about this policy?" | translate }}
            </div>
            <div class="margin-top mt16">
              <app-billing-question></app-billing-question>
            </div>
          </div>
        </div> -->
      </div>
    </ng-template>
  </section>
</mapfre-card>

